import { type KeyboardEvent } from 'react';

import { KEYBOARD_CODES } from '../../../../constants';

import type { SelectableItemProps } from './types';

export const useKeyboardInteraction = (props: SelectableItemProps) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    /**
     * Ignore key navigation if:
     * - the target is not the active element
     * - the control or alt key is pressed
     */
    if (
      e.target !== document.activeElement ||
      e.ctrlKey ||
      e.altKey ||
      !props.onSelectionChange
    ) {
      return;
    }

    switch (e.key) {
      case KEYBOARD_CODES.SPACE:
        e.preventDefault();
        props.onSelectionChange(!props.selected);
        break;
    }
  };

  return handleKeyDown;
};
